import type { ReactElement } from 'react';
import DataTablePluginsTab from './DataTablePluginsTab';

/**
 * Personal Plugins tab for the user dashboard.
 * Delegates to DataTablePluginsTab which provides filtering,
 * sorting, search, and pagination via the shared DataTable component.
 */
export default function PluginsTab(): ReactElement {
  return <DataTablePluginsTab />;
}
